// extracted by mini-css-extract-plugin
export default {"overlay":"main-overlay_NOm0I","dots":"main-dots_OLOFJ","dot":"main-dot_yWYdD","bounce":"main-bounce_fgKT4"};